import { Dropdown } from "capitalrx-components-2.0/lib/forms";

export const renderLevelOptions = [
  {
    value: "level_1",
    label: "Level 1",
  },
  {
    value: "level_2",
    label: "Level 2",
  },
  {
    value: "level_3",
    label: "Level 3",
  },
].map((option) => (
  <Dropdown.Option key={option.value} value={option.value}>
    {option.label}
  </Dropdown.Option>
));

export const renderOverpaymentMethodOptions = [
  {
    value: "increase_pharmacy_gross_amount",
    label: "Increase Pharmacy Gross Amount Due",
  },
  {
    value: "decrease_patient_pay",
    label: "Decrease Patient Pay",
  },
].map((option) => (
  <Dropdown.Option key={option.value} value={option.value}>
    {option.label}
  </Dropdown.Option>
));
